// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2117":"5485cae9","6422":"5485cae9","8494":"5485cae9"}[chunkId] + ".chunk.css";
};